module.exports = __webpack_public_path__ + "img/tooltipSHA.484b0170.svg";